import { Button } from "@mui/material";
import { InstallMobile } from '@mui/icons-material';
import useIsMobile from "./hooks/useIsMobile";
import config from "../config";
import { useDeviceType } from "./hooks";

const { urls } = config.pwa;
const PLAY_STORE_URL = urls.android;
const APP_STORE_URL = urls.ios;

const InstallPwaButton = () => {
  const isMobile = useIsMobile();
  const deviceType = useDeviceType();

  // Check if running as installed PWA
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches 
    || window.navigator.standalone // for iOS
    || document.referrer.includes('android-app://');

  if (!isMobile || isStandalone) {
    return null;
  }

  const isAndroid = deviceType === 'android';
  const isIOS = deviceType === 'ios';
  
  const getStoreUrl = () => {
    if (isAndroid) return PLAY_STORE_URL;
    if (isIOS) return APP_STORE_URL;
    return null;
  };

  const storeUrl = getStoreUrl();
  if (!storeUrl) return null;

  return (
    <Button 
      href={storeUrl}
      target="_blank"
      rel="noopener noreferrer"
      color="success" 
      style={{ textTransform: "none", fontSize: "1.5rem" }}
    >
      Instalá la app <InstallMobile />
    </Button>
  );
};

export default InstallPwaButton;